export enum ApprovalStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  ChangesRequested = 'changes_requested',
}

export enum ApprovalType {
  Inspection = 'inspection',
  Issue = 'issue',
}
